/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown>, requestId: NonNullable<unknown> }} Tea_Machines_Stale_WarningInputs */

const vi_tea_machines_stale_warning = /** @type {(inputs: Tea_Machines_Stale_WarningInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mất kết nối máy vò từ ${i?.time} — số liệu đang hiển thị là cũ. Mã: ${i?.requestId}`)
};

/**

* @param {Tea_Machines_Stale_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_machines_stale_warning = /** @type {((inputs: Tea_Machines_Stale_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Machines_Stale_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_machines_stale_warning(inputs)
});